export default {
      id: "menu__history-usage",
      viewBox: "0 0 144 105",
      url: __webpack_public_path__ + "img/icons.svg#menu__history",
      toString: function () {
        return this.url;
      }
    }